import React from "react";
import { credentialMedia } from "../../data/credentialMedia";
export function CredentialRecognition() {
  return <aside aria-labelledby="ntl-recognition-title" className="attorney-credential" data-id="element-220" data-mp="1nfadh2bk5qtl">
    <div className="credential-summary" data-id="element-221" data-mp="1in0phru070ty">
      <img src={credentialMedia.badge.src} width={280} height={280} alt={credentialMedia.badge.alt} loading="lazy" decoding="async" data-id="element-222" data-mp="1ilxyljwokye1" />
      <div data-id="element-223" data-mp="19mugoj992p14">
        <h3 id="ntl-recognition-title" data-id="element-224" data-mp="19mkt12bogtyl">The National Trial Lawyers</h3>
        <p className="credential-category" data-id="element-225" data-mp="19krktilf21oh">Top 100 — Civil Plaintiff</p>
        <p className="credential-date" data-id="element-226" data-mp="14m6gp831mxur">Membership certificate dated <time dateTime="2026-04-14" data-id="element-227" data-mp="zo4xmn5mayja">April 14, 2026</time>.</p>
      </div>
    </div>
  </aside>;
}